import { ArrowDown, ArrowRight } from "lucide-react";
import { Chapter, Reveal } from "@/components/Reveal";

const FLOW = [
  { t: "ANALISI", link: "BF360" },
  { t: "CONSULENZA", link: null },
  { t: "STRATEGIA", link: null },
  { t: "IMPLEMENTAZIONE", link: "Δ DELTA" },
  { t: "MISURAZIONE", link: null },
];

const Ecosystem = () => (
  <section id="ecosistema" data-testid="ecosystem-section" className="bg-fog py-28 text-ink lg:py-40">
    <div className="mx-auto max-w-[1440px] px-6 lg:px-12">
      <Chapter index="11" label="Ecosistema" />
      <Reveal>
        <h2 className="max-w-3xl font-display text-4xl font-extrabold leading-[1.05] tracking-tighter sm:text-5xl">
          Un unico ecosistema. Un unico obiettivo: la crescita.
        </h2>
      </Reveal>

      <ol className="mt-16 flex flex-col gap-6 lg:mt-24 lg:flex-row lg:items-start" data-testid="ecosystem-flow">
        {FLOW.map((step, i) => (
          <li key={step.t} className="flex items-center gap-6 lg:flex-1 lg:flex-col lg:items-stretch lg:gap-0">
            <Reveal delay={i * 0.08} className="flex-1">
              <div className="border border-ink/10 bg-white px-6 py-6 transition-colors duration-500 hover:border-accent">
                <span className="font-mono text-[10px] tracking-[0.3em] text-ink/35">0{i + 1}</span>
                <p className="mt-2 font-display text-lg font-bold tracking-tight">{step.t}</p>
                {step.link && (
                  <p className="mt-3 inline-block border border-accent-dark/40 px-2 py-1 font-mono text-[9px] uppercase tracking-[0.2em] text-accent-dark">
                    {step.link}
                  </p>
                )}
              </div>
            </Reveal>
            {i < FLOW.length - 1 && (
              <>
                <ArrowDown className="h-4 w-4 shrink-0 text-ink/25 lg:hidden" aria-hidden="true" />
                <ArrowRight className="mt-9 hidden h-4 w-4 shrink-0 text-ink/25 lg:block" aria-hidden="true" />
              </>
            )}
          </li>
        ))}
      </ol>

      <Reveal delay={0.2} className="mt-12">
        <p className="max-w-2xl font-mono text-[11px] uppercase leading-relaxed tracking-[0.2em] text-ink/40">
          BF360 alimenta l'analisi. La consulenza genera la strategia. Delta Digital Agency cura
          l'implementazione. Ogni progetto fa parte dello stesso sistema.
        </p>
      </Reveal>
    </div>
  </section>
);

export default Ecosystem;
